import {ContentBody, DefaultContentBody, Image as DCImage} from 'dc-delivery-sdk-js'
import { ProductModel } from '../../store/ProductStore'
import { BoxProps } from '../../vanilla'
import { MarketingFormCmsContent } from './marketing-form'
import { CompetitionMarketingFormCmsContent } from './competition-marketing-form'

export enum TextAlignment {
  LEFT = 'Left', 
  RIGHT = 'Right',
  CENTER = 'Center'
}

export enum ScreenSize { 
  DESKTOP = 'Desktop',
  TABLET = 'Tablet',
  MOBILE = 'Mobile'
} 

export interface ColorPicker {
  color: string
  name: string
  theColor?: string
}

export interface MediaLink extends ContentBody {
  id: string
  name: string
  endpoint: string
  defaultHost: string
  mimeType?: string
}

export interface Image {
  data: {
    altText?: string
    screen?: 'desktop' | 'tablet' | 'mobile' // @TODO Only type that is lowercase schema needs updating to match ScreenSize for consistency
  }
  image: MediaLink
}

/*
  NOTE: the name "ImageLink" matches the name of the partial on Amplience (`image-link`).
  This is semantically completely different from the MediaLink type also defined on this file.
  ImageLink contains the link where the user is redirected when they click the image, as
  opposed to MediaLink, which describes the location of the image.
 */
export type ImageLink = string

export interface CTA {
  ctaText: string
  ctaLink: string
  ctaButtonColor: ColorPicker
  ctaTextColor: ColorPicker
  ctaPosition?: TextAlignment
}

export interface ImageGroup {
  images: Image[]
}

export interface DCImageGroup {
  images: { image: DCImage }[] 
}

export interface ImageLinkGroup {
  imageLink: ImageLink
  image: ImageGroup
}

export interface SEO {
  pageTitle: string
  pageDescription: string
}

export interface PageHeading {
  textAlignment: TextAlignment
  heading?: string
  heading2?: string
}

export interface PresentationAttributes {
  hideBreadCrumbs: boolean
  hideExpiredPromotions: boolean
  hideProductListing: boolean
  hideSearchSuggestions: boolean
  hideTitle: boolean
  hideSponsoredProducts: boolean
}

export interface Category {
  name: string
  id: string
}

export interface ProductList {
    products: ProductModel[]
}

export interface Einstein {
  recommenderId?: string
}

export interface CloseButton {
  closeBackgroundColor: ColorPicker
  closeColor: ColorPicker
}

export interface CustomerGroup {
  id: string
  name: string
}

export interface VariationContent<T1> {
  contentItems: T1
  customerGroups: {
    rank: number
    customerGroups: CustomerGroup[]
  }
}

export interface CMSContent<T1> extends DefaultContentBody {
  categoryList?: Category[]
  productList?: ProductList
  default: T1 & DefaultContentBody
  variations: VariationContent<T1>[]
}

export interface CMSVideo {
  screenSize?: ScreenSize
  videoID: string
}

export interface CMSAccordion {
  accordionID: string
  accordionText: {richText: string}
  isAccordianOpen: boolean
  title: string
}

export enum IconType {
  CHEVRON = 'chevron',
  PLUS = 'plus'
}

  export enum VideoType { 
    YOUTUBE = 'youtube',
    VIMEO = 'vimeo',
    AMPLIENCE = 'amplience'
  }

  export type TextAlign = BoxProps<any>['textAlign']

  export interface ContentTab {
    tabTitle: string
    tabID: string
    tabText: string
    _meta?: {
      deliveryId: string
    }
    enableLastPublishedDate: boolean
  }

  export interface ButtonGroupButton {
    ctaButtonColor: ColorPicker
    ctaTextColor: ColorPicker
    ctaText: string
    ctaLink: string
  }

  export enum TextSizeOrSpacing {
    NONE = 'None',
    SMALL = 'Small',
    MEDIUM = 'Medium',
    LARGE = 'Large'
  }

  export enum TextPosition {
    NONE = 'None',
    MIDDLE = 'Middle',
    TOP = 'Top'
  }

  export interface AlternatingTextImage {
    image: {
      imageOnRight: boolean
      image: ImageGroup
    }
    text: {
      body: string
      headline: string
      eyebrow?: string
    }
    textControls: {
      textAreaSpacing: TextSizeOrSpacing
      textPosition: TextPosition
    }
    marketingModal?: {
      ctaText: string
      badgeIcon: string
      marketingForm: MarketingFormCmsContent | CompetitionMarketingFormCmsContent
      } & DefaultContentBody
      cta?: CTA
  }

  export interface PrizesData {
    prizesWonData: {data: string}[]
    prizeWonText: {
      backgroundColor: ColorPicker
      textColor: ColorPicker
      prizesWonHeading: string
    }
  }

  export interface Timer {
    countdownBackgroundColor: ColorPicker
    countdownDate: string
    countdownTextColor: ColorPicker
    headline: string
  }

  export type CmsImageQueryParameters = {
    fmt?: string
    h?: number
    qlt?: number | string
    template?: string
    w?: number
  }[]